import CompanyService from '../services/company.service';
import {
  User, CompanyType, Company, CompanyCompanyType, Location,
} from './models/models';

export default {
  namespaced: true,
  state: {
    companyId: null,
    totalCompanies: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
  },
  mutations: {
    companyId(state, companyId) {
      state.companyId = companyId;
    },
    totalCompanies(state, totalCompanies) {
      state.totalCompanies = totalCompanies;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getCompanies');
      dispatch('getCompanyTypes');
    },
    newCompany({ commit }) {
      Company.new()
        .then((company) => {
          commit('companyId', company.id);
        });
    },
    updateCompanyProps({ state }, props) {
      if (props.hasOwnProperty('location')) {
        Location.insert({ data: props.location });
      }
      if (props.hasOwnProperty('default_contact_user')) {
        User.insert({ data: props.default_contact_user });
      }
      if (props.hasOwnProperty('types')) {
        // Delete previous
        CompanyCompanyType.delete((companyType) => companyType.company_id === state.companyId);
        // Add again
        CompanyCompanyType.insert({
          data: props.types.map((companyType) => ({
            company_id: state.companyId,
            company_type_code: companyType.code,
          })),
        });
      } else {
        Company.update({
          where: state.companyId,
          data: props,
        });
      }
    },
    assignUserToCompany({ state }, userId) {
      return CompanyService.attachUser(state.companyId, userId)
        .then((res) => {
          User.insertOrUpdate({ data: [res] });
        });
    },
    getCompanyTypes() {
      return CompanyService.getCompanyTypes()
        .then((res) => {
          CompanyType.create({
            data: res,
          });
        });
    },
    getCompanies({ commit, state }) {
      return CompanyService.getCompanies(state.query)
        .then((res) => {
          commit('totalCompanies', res.total);
          Company.create({
            data: res.data,
            insertOrUpdate: ['countries', 'currencies', 'users'],
          });
        });
    },
    suggestCompanies(store, query) {
      return CompanyService.suggestCompanies(query);
    },
    getCompany({ commit }, id) {
      return CompanyService.getCompany(id)
        .then((company) => {
          Company.insert({ data: [company] })
            .then(() => {
              commit('companyId', company.id);
            });
        });
    },
    createCompany({ getters }) {
      return CompanyService.createCompany(getters.company);
    },
    updateCompany({ getters, dispatch }) {
      return CompanyService.updateCompany(getters.company)
        .then((res) => {
          if (res.hasOwnProperty('company_id')) {
            dispatch('getCompany', res.company_id);
          }
          return res;
        });
    },
    deleteCompany({ getters }) {
      return CompanyService.deleteCompany(getters.company)
        .then((res) => {
          if (res.hasOwnProperty('company_id')) {
            Company.delete(res.company_id);
          }
          return res;
        });
    },
  },
  getters: {
    companies() {
      return Company.query()
        .with(['location.country', 'types'])
        .get();
    },
    company(state) {
      if (!state.companyId) {
        return null;
      }
      return Company.query()
        .withAllRecursive()
        .find(state.companyId);
    },
    companyTypes() {
      return CompanyType.query()
        .all();
    },
  },
};
